// Note: The first file of a module here, must also register the module

import "./choose-import.component";
import "./nation-builder.component";
import "./nation-form.component";
